module.exports = __webpack_public_path__ + "static/media/26.c47e5cec.jpg";